export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "search-placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search..."])},
        "no-results-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No results found"])},
        "clear-search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear search"])}
      },
      "fr": {
        "search-placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher..."])},
        "no-results-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun résultat trouvé"])},
        "clear-search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer la recherche"])}
      }
    }
  })
}
